export class CallUser {
  protected uid!: string;
  protected name!: string;
  protected avatar!: string;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(object: any) {
    Object.assign(this, object);
  }

  getUid(): string {
    return this.uid;
  }

  setUid(uid: string): void {
    this.uid = uid;
  }

  getName(): string {
    return this.name;
  }

  setName(name: string): void {
    this.name = name;
  }

  getAvatar(): string {
    return this.avatar;
  }

  setAvatar(avatar: string): void {
    this.avatar = avatar;
  }

  toString(): string {
    return `CallUser{ uid='${this.uid}', name='${this.name}', avatar='${this.avatar}' }`;
  }
  static getUserFromJson(object: any): CallUser {
    let callUser = new CallUser(object);
    return callUser;
  }
}
